import { render, staticRenderFns } from "./RioDeJaneiro.vue?vue&type=template&id=2e955334&"
import script from "./RioDeJaneiro.vue?vue&type=script&lang=js&"
export * from "./RioDeJaneiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports